<template>
  <div class="form-container">
    <h2>Formulario de Aliado</h2>
    <form @submit.prevent="guardarAliado" class="form">
      <div class="form-group">
        <label for="nombre">Nombre del Aliado:</label>
        <input
          type="text"
          id="nombre"
          v-model="aliado.nombre"
          required
          class="form-control"
        />
      </div>
      <div class="form-group">
        <label for="nit">NIT:</label>
        <input
          type="text"
          id="nit"
          v-model="aliado.nit"
          required
          class="form-control"
        />
      </div>
      <div class="form-group">
        <label for="ciudad">Ciudad:</label>
        <input type="text" id="ciudad" v-model="aliado.ciudad" class="form-control" />
      </div>
      <div class="form-group">
        <label for="direccion">Dirección:</label>
        <input
          type="text"
          id="direccion"
          v-model="aliado.direccion"
          class="form-control"
        />
      </div>
      <div class="form-group">
        <label for="telefono">Teléfono:</label>
        <input
          type="text"
          id="telefono"
          v-model="aliado.telefono"
          class="form-control"
        />
      </div>
      <div class="form-group">
        <label for="observaciones">Observaciones:</label>
        <textarea
          id="observaciones"
          v-model="aliado.observaciones"
          class="form-control"
        ></textarea>
      </div>
      <div class="button-group">
        <button type="submit" id="enviar" class="btn">Enviar</button>
        <button id="cancelar" @click="devolver()">Cancelar</button>
      </div>
    </form>
  </div>
</template>
  
  <script>
import Swal from "sweetalert2";
import HttpService from "../../Servicios/HttpService";
export default {
  data() {
    return {
      aliado: {
        nombre: "",
        nit: "",
        ciudad: "",
        direccion: "",
        telefono: "",
        observaciones: "",
      },
    };
  },

  mounted() {
      this.ObtenerPorId();
    },
  
  methods: {
    guardarAliado() {
      let payload = {
        accion: "editarAliado",
        aliado: this.aliado,
        id:this.aliado.id,
      };
      HttpService.registrar("reportes.php", payload).then((registrado) => {
        if (registrado) {
          Swal.fire({
            title: "Registro de formulario",
            text: "Registrado",
            icon: "success",
            confirmButtonText: "Aceptar",
          }).then(() => {
            window.location.reload();
          });
        }
      });
    },
    devolver() {
      this.$router.push({
        name: "DatosAliados",
      });
    },
    ObtenerPorId() {
      let payload = {
        accion: "obtenerAliadoId",
        id: this.$route.params.id,
      };
      HttpService.obtenerConConsultas("reportes.php", payload).then(
        (aliado) => {
          this.aliado = aliado[0];
        }
      );
    },
  },
};
</script>
  
  <style scoped>
.form-container {
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  font-weight: bold;
}

input[type="text"],
input[type="date"],
input[type="tel"],
select,
textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

button {
  margin-right: 10px;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

#enviar {
  background-color: #4caf50;
}

#cancelar {
  background-color: #eb535b;
}

button:hover {
  background-color: #45a049;
}
</style>